import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserCoffeeService} from '../../../services/user/user-coffee.service';
import {Router} from '@angular/router';
import {User} from '../../../classes/User';
import {LocalStorageService} from '../../../services/local-storage.service';
import {CoffeeCode} from '../../../classes/CoffeeCode';
import {interval, takeWhile} from 'rxjs';
import {CoffeeCodeStatus} from '../../../enums/CoffeeCodeStatus';

@Component({
  selector: 'app-coffee-use',
  styleUrls: ['./coffee-use.component.scss'],
  templateUrl: './coffee-use.component.html',
})
export class CoffeeUseComponent implements OnInit, OnDestroy {

  public isSuccess = false;
  public errorMessage: string;
  public currentUser: User;
  public coffeeCode: CoffeeCode;
  public isRollingUpdate = false;
  public isCoffeeCodeUsed = false;

  constructor(private userCoffeeService: UserCoffeeService,
              private router: Router,
              private localStorageService: LocalStorageService) {
    this.currentUser = this.localStorageService.getUser();
  }

  ngOnInit(): void {
    this.userCoffeeService.createCoffeeCode().subscribe({
      next: (response: CoffeeCode) => {
        this.coffeeCode = response;
        this.isRollingUpdate = true;
        const subs =
          interval(3000)
            .pipe(takeWhile(x => this.isRollingUpdate))
            .subscribe(x => this.rollingUpdate());
      },
      error: (e) => {
        this.isSuccess = false;
        this.errorMessage = e.error.message;
      }
    });
  }

  ngOnDestroy(): void {
    this.isRollingUpdate = false;
  }

  returnToProfile(): void {
    this.router.navigate(['/user']).then();
  }

  private rollingUpdate(): void {
    this.userCoffeeService.getCoffeeCodeStatus(this.coffeeCode.id).subscribe({
      next: (response: CoffeeCode) => {
        this.isSuccess = true;
        if (response.status === CoffeeCodeStatus.USED) {
          this.isRollingUpdate = false;
          this.isCoffeeCodeUsed = true;
        }
        if (response.status === CoffeeCodeStatus.EXPIRED) {
          this.isRollingUpdate = false;
          this.isSuccess = false;
          this.errorMessage = 'Your coffee code is expired';
        }
      },
      error: (e) => {
        this.isSuccess = false;
        this.errorMessage = e.error.message;
      }
    });
  }
}
